import React, { useState } from 'react';
import {
 SumPayBlock,
 PaymentButton,
 PaymentButtonSbp,
 PaymentButtonRuble,
 PaymentButtonCard,
 Description,
} from './SumPay.styled';
import CloseIcon from '@mui/icons-material/Close';
import { Box, BoxProps } from '@mui/material';
import { RootState } from '../../../../store/store';
import { shallowEqual, useSelector } from 'react-redux';

interface Props {
 isSubmiting?: boolean;
 inputSum?: number;
 parentUnit?: string | null;
}
const SumPay = ({ isSubmiting, inputSum, parentUnit }: Props) => {
 const [payButtonEnabled, setPayButtonEnabled] = useState(false);

 const configData = useSelector(
  (state: RootState) => state.config,
  shallowEqual,
 );

 const SbpIcon = (props: BoxProps) => {
  return (
   <Box
    component="svg"
    viewBox="0 0 98 120"
    sx={{ width: 24, height: 24, display: 'inline-block', ...props.sx }}
    {...props}
   >
    <path
     d="M0 26.12l14.532 25.975v15.844L.017 93.863 0 26.12z"
     fill="#5B57A2"
    />
    <path
     d="M55.797 42.643l13.617-8.346 27.868-.026-41.485 25.414V42.643z"
     fill="#D90751"
    />
    <path
     d="M55.72 25.967l.077 34.39-14.566-8.95V0l14.49 25.967z"
     fill="#FAB718"
    />
    <path
     d="M97.282 34.271l-27.869.026-13.693-8.33L41.231 0l56.05 34.271z"
     fill="#ED6F26"
    />
    <path
     d="M55.797 94.007V77.322l-14.566-8.78.008 51.458 14.558-25.993z"
     fill="#63B22F"
    />
    <path
     d="M69.38 85.737L14.531 52.095 0 26.12l97.223 59.583-27.844.034z"
     fill="#1487C9"
    />
    <path
     d="M41.24 120l14.556-25.993 13.583-8.27 27.843-.034L41.24 120z"
     fill="#017F36"
    />
    <path
     d="M.017 93.863l41.333-25.32-13.896-8.526-12.922 7.922L.017 93.863z"
     fill="#984995"
    />
   </Box>
  );
 };

 const RubleIcon = (props: BoxProps) => {
  return (
   <Box
    component="svg"
    viewBox="0 0 1000 1000" // Исправили viewBox под размер координат (~1000x1000)
    sx={{
     width: 42, // Реальная ширина иконки на экране (можно менять)
     height: 42, // Реальная высота иконки на экране
     ...props.sx,
    }}
    {...props}
   >
    {' '}
    <g transform="translate(500, 500) scale(1.2) translate(-500, -500)">
     <path
      fill="white"
      d="M725.4901733,274.5097961C665.3594971,214.3790741,585.6209106,181.0457611,500,181.0457611
		s-165.3594666,33.333313-225.4902039,93.464035S181.0457611,414.3790894,181.0457611,500
		c0,84.9673462,33.333313,165.3594971,93.464035,225.4901733C334.6405334,785.6209106,414.3790894,818.9542847,500,818.9542847
		s165.3594971-33.333313,225.4901733-93.4641113C785.6209106,665.3594971,818.9542847,585.6209106,818.9542847,500
		C818.3006592,415.0326843,785.6209106,334.6405334,725.4901733,274.5097961z M339.2156982,267.320282v203.2679443H218.9542542
		C227.4509735,386.9281006,273.2026062,313.7254944,339.2156982,267.320282z M339.2156982,586.9281006H230.7189484
		c-5.8823395-18.3006592-9.8039246-37.9085083-11.7646942-57.5163574h120.2614441V586.9281006z M257.5163574,645.0980225h81.6993408
		v87.5817261C305.8823547,709.803894,278.431366,679.7385864,257.5163574,645.0980225z M500,782.3529053
		c-36.6012878,0-71.2418518-6.5359497-102.6143799-19.6078491V645.0980225h132.026123v-58.1699219h-132.026123v-57.5163574
		h78.4313965c128.7581177,0,184.3137207-66.013031,184.3137207-146.4052124
		c0-77.124176-45.0980835-145.098053-184.3137207-145.098053l-83.6601562,0.6536102
		C425.4901733,224.8366089,462.0914917,216.9934692,500,216.9934692c156.2091675,0,282.3529053,126.7973633,282.3529053,282.3529358
		S656.2091675,782.3529053,500,782.3529053z M397.3856201,471.2418213V296.7320251l81.6993713-0.6535645
		c79.7385559,0,114.3790588,32.679718,114.3790588,88.888855c0,56.8627319-39.8692627,86.2745056-119.6078491,86.2745056
		H397.3856201z"
     />
    </g>
   </Box>
  );
 };

 const handlePay = () => {
  setPayButtonEnabled(!payButtonEnabled);
 };

 const setPaymentType = () => {
  sessionStorage.removeItem('paymentType');
  sessionStorage.setItem('paymentType', '0');
  setTimeout(() => {
   setPayButtonEnabled(false);
  }, 1000);
 };

 const setPaymentTypeSbp = () => {
  sessionStorage.removeItem('paymentType');
  sessionStorage.setItem('paymentType', 'SBP');
  setTimeout(() => {
   setPayButtonEnabled(false);
  }, 1000);
 };

 const setPaymentTypeRuble = () => {
  sessionStorage.removeItem('paymentType');
  sessionStorage.setItem('paymentType', 'DR');
  setTimeout(() => {
   setPayButtonEnabled(false);
  }, 1000);
 };

 return (
  <React.Fragment>
   <SumPayBlock>
    <Description>
     Итого к оплате: <b>{inputSum ? `${inputSum.toFixed(2)}₽` : `0₽`}</b>
    </Description>

    <PaymentButton disabled={inputSum ? false : true} onClick={handlePay}>
     Оплатить
    </PaymentButton>
   </SumPayBlock>

   {payButtonEnabled ? (
    <div
     style={{
      display: 'flex',
      flexDirection: 'column',
      width: '400px',
      height: '220px',
      border: '1px solid gray',
      backgroundColor: '#ffffff',
      boxShadow:
       '0 25px 60px rgba(0, 0, 0, 0.45), 0 10px 25px rgba(0, 0, 0, 0.3), 0 2px 6px rgba(0, 0, 0, 0.2)',
      justifyContent: 'center',
      justifyItems: 'center',
      alignContent: 'center',
      alignItems: 'center',
      borderRadius: '10px',
      position: 'fixed',
      top: '40%',
      left: '40%',
      zIndex: 100,
     }}
    >
     <div
      style={{
       display: 'flex',
       flexDirection: 'row',
       justifyContent: 'space-between',
       justifyItems: 'space-between',
       alignContent: 'space-between',
       alignItems: 'space-between',
       width: '100%',
       marginTop: '-40px',
       marginRight: '10px',
       fontWeight: 800,
       color: 'red',
       marginBottom: '-5px',
       cursor: 'pointer',
      }}
     >
      <label
       style={{
        color: 'black',
        fontSize: '21px',
        lineHeight: '18px',
        marginBottom: '20px',
        marginLeft: '30px',
        marginTop: '25px',
        fontWeight: 600,
       }}
      >
       Выберите способ оплаты:
      </label>

      <CloseIcon
       sx={{ cursor: 'pointer', marginTop: '20px' }}
       onClick={handlePay}
      />
     </div>

     <PaymentButtonCard
      style={{ width: '350px', backgroundColor: '#00BFFF', color: 'white' }}
      htmlType="submit"
      onClick={setPaymentType}
     >
      Оплатить банковской картой
     </PaymentButtonCard>

     {parentUnit && (
      <PaymentButtonSbp
       style={{
        width: '350px',
        backgroundColor: 'black',
        color: 'white',
        border: 'none',
       }}
       htmlType="submit"
       onClick={setPaymentTypeSbp}
      >
       <div
        style={{
         display: 'flex',
         flexDirection: 'row',
         marginLeft: '10px',
         justifyContent: 'center',
         justifyItems: 'center',
         alignContent: 'center',
         alignItems: 'center',
         cursor: 'pointer',
        }}
       >
        <label
         style={{
          color: 'white',
          fontSize: '18px',
          lineHeight: '18px',
          marginRight: '5px',
          cursor: 'pointer',
         }}
        >
         Оплатить
        </label>{' '}
        <SbpIcon color="primary" />{' '}
        <label
         style={{
          color: 'white',
          fontSize: '18px',
          lineHeight: '18px',
          marginTop: '1px',
          marginLeft: '5px',
          cursor: 'pointer',
         }}
        >
         СБП
        </label>
       </div>
      </PaymentButtonSbp>
     )}

     <PaymentButtonRuble
      style={{
       width: '350px',
       backgroundColor:
        configData.showDititalRubblePayment === '1' ? 'red' : 'lightgrey',
       color: 'white',
       border: 'none',
       cursor:
        configData.showDititalRubblePayment === '1' ? 'pointer' : 'disables',
       fontSize: '12px',
      }}
      disabled={configData.showDititalRubblePayment === '1' ? false : true}
      sx={{ fontSize: 10 }}
      htmlType="submit"
      onClick={setPaymentTypeRuble}
     >
      <div
       style={{
        display: 'flex',
        flexDirection: 'row',
        marginLeft: '10px',
        justifyContent: 'center',
        justifyItems: 'center',
        alignContent: 'center',
        alignItems: 'center',
        borderRadius: 0,
       }}
      >
       <label
        style={{
         color: 'white',
         fontSize: '18px',
         lineHeight: '18px',
         marginRight: '5px',
         cursor: 'pointer',
         marginTop: '-10px',
        }}
       >
        Оплатить цифровым рублем
       </label>{' '}
       <RubleIcon
        color="primary"
        style={{
         color: 'white',
         marginTop: '-6px',
         width: '40px',
         height: '40px',
        }}
       />{' '}
      </div>
     </PaymentButtonRuble>
    </div>
   ) : (
    ''
   )}
  </React.Fragment>
 );
};

export default SumPay;
